var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((this.sectionsToRender),function(section){return _c('owal-list-section',{key:section.identifier,attrs:{"items":section.items,"title":section.title},scopedSlots:_vm._u([{key:"default",fn:function(item){return _c('div',{},[_c('owal-list-row',{attrs:{"item":item}},[_vm._t("default",null,null,item)],2)],1)}}],null,true)})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }